import {RequestMethod} from '@angular/http';
import {RequestConfig, RestResponse} from "../shared/rest/rest.request";
import {CustomHttp} from "../common/http/custom.http";
import {Observable} from "rxjs/Observable";
import {Injectable} from "@angular/core";
import {PageImpl} from "../common/http/PageImpl";
import { es_ES, NzI18nService } from 'ng-zorro-antd/i18n';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from 'environments/environment';

@Injectable()
export class GeocercasService {
    private GET_ALL_CODE = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/geofences");
    private CREATE_CODE = new RequestConfig("GEO", "application/json", true, RequestMethod.Post, "/geofences");
    private EDIT_CODE = new RequestConfig("GEO", "application/json", true, RequestMethod.Put, "/geofences/{idGeofence}");
    private DELETE_CODE = new RequestConfig("GEO", "application/json", true, RequestMethod.Delete, "/geofences/{idGeofence}");
    private GET_CODE = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/geofences/{idGeofence}");
    private GET_PAGE = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/geofences");
    private GET_PAGE_NEW = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/geofences-dash/page");
    private GET_GEOFENCES = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/geofences-dash");
    private GET_MULTIPLE = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/geofences/multiple");
    private EDIT_MULTI_GEO = new RequestConfig("GEO", "application/json", true, RequestMethod.Put, "/geofences/editMultiple");
    private GET_TICKETS_BY_GEOFENCE = new RequestConfig("GEO", "application/json", true, RequestMethod.Get, "/reportes/ticketsAutoA");
    private GET_GEOFENCES_DETAIL = new RequestConfig("GEO", "application/json", true, RequestMethod.Post, "/reportes/geofencesInfo");
    private UPDATE_GEOFENCE_CUADRILLAS = new RequestConfig("GEO", "application/json", true, RequestMethod.Put, "/users/updateGeofence/cuadrilas");
    private CREATE_GEOFENCES = new RequestConfig("GEO", "application/json", true, RequestMethod.Post, "/geofences/multiple");

    constructor(private http: CustomHttp,
        private i18n: NzI18nService,
        private httpClient: Http) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar geocerca
     */
    saveGeocerca(geocerca: GeofenceView): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, geocerca)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de las geocerca
     */
    getAll(): Observable<Array<Geocerca>> {
        return this.http.sendRequest(this.GET_ALL_CODE)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de una geocerca
     */
    getGeocerca(idGeofence: number): Observable<GeofenceView> {
        return this.http.sendRequest(this.GET_CODE, {}, idGeofence)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de geocerca
     */
    updateGeocerca(geocerca: GeofenceView): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, geocerca, geocerca.idGeofence)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de geocerca
     */
    deleteGeocerca(idGeofence: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idGeofence)
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<Geocerca>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getPageNew(options: any): Observable<PageImpl<GeofencePageCompositiveView>> {
        return this.http.sendRequest(this.GET_PAGE_NEW, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getGeofences(idGeofences: number[], description?: boolean): Observable<GeofencesDashboard[]> {
        return this.http.sendRequest(this.GET_GEOFENCES, {idGeofences: idGeofences, description})
            .map((res) => {
                try {
                    return (res.json() as GeofencesDashboard[])
                        .map((geofenceDashboard) => {
                            geofenceDashboard.ticketData.forEach((geofenceTicketData) => {
                                geofenceTicketData.latitud = +(geofenceTicketData.latitud);
                                geofenceTicketData.longitud = +(geofenceTicketData.longitud);
                            });

                            return geofenceDashboard;
                        });
                } catch(e) {
                    return [];
                }
            })
            .catch(error => this.http.handleError(error));
    }

    getMultiple(idTypeTicket: number, idGroup: number, idCategory: number, geofenceType: any): Observable<GeofenceView[]> {
        return this.http.sendRequest(this.GET_MULTIPLE, {idTypeTicket: idTypeTicket, idGroup: idGroup, idCategory: idCategory, geofenceType: geofenceType})
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    /**
     * Envia una petición a WS para guardar geocerca
     */
    updateGeocercaMulti(geocerca: GeoMultiView): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_MULTI_GEO, geocerca)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    // Funcion para Generar reporte de Tickets en geocercas y la tabla de geocercas
    ticketsInGeofences( data ):Observable<any>{
      console.log(data);
      return this.http.sendRequest(this.GET_TICKETS_BY_GEOFENCE, {idGeofence:data})
      .map(res => res.json())
      .catch(error => this.http.handleError(error));
    }

    detailGeofences(data: DetailGeofencesRequest): Observable<DetailGeofencesResponse> {
        return this.http.sendRequest(this.GET_GEOFENCES_DETAIL, data)
            .map(res => {
                const data = res.json();
                // Sumar totales
                const totals = data.reduce((acc, item) => ({
                    totalTickets: acc.totalTickets + item.numberOfTickets,
                    totalUsers: acc.totalUsers + item.numberOfUsers
                }), { totalTickets: 0, totalUsers: 0 });
                // Obtener array único de users
                const allUsers = data.flatMap(item => item.users);
                // Extraer solo los ids de usuarios
                const userIds = allUsers.map(user => user.idUser);
                return {
                    numberOfTickets: totals.totalTickets,
                    numberOfUsers: totals.totalUsers,
                    users: allUsers,
                    ids: userIds
                };
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Actualiza las cuadrillas asignadas a una geocerca
     */
    updateGeofenceCuadrillas(data: UpdateGeofenceCuadrillasRequest): Observable<any> {
        return this.http.sendRequest(this.UPDATE_GEOFENCE_CUADRILLAS, data)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Crea geocercas desde un archivo JSON
     */
    createGeofencesFromJson(jsonData: any): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_GEOFENCES, jsonData)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Obtiene geocercas desde el servicio externo de Geomega
     * @param numSuc Número de la sucursal a consultar (obligatorio)
     * @param penetracion Umbral de penetración máxima (%) - default: 11 (opcional)
     */
    getGeofencesFromGeomega(numSuc: number, penetracion: number = 11): Observable<any> {
        const url = environment.GEOMEGA_GEOFENCE_URL;
        const token = environment.GEOMEGA_GEOFENCE_TOKEN;
        
        const headers = new Headers();
        headers.append('token', token);
        headers.append('Content-Type', 'application/json');
        
        const body = {
            num_suc: numSuc,
            penetracion: penetracion
        };
        
        const options = new RequestOptions();
        options.headers = headers;
        
        console.log('Llamando a servicio externo de geocercas:', url);
        console.log('Body:', body);
        
        return this.httpClient.post(url, body, options)
            .map((res) => {
                console.log('Respuesta del servicio externo:', res);
                console.log('Body de respuesta:', res.json());
                return res.json();
            })
            .catch(error => {
                console.error('Error en servicio externo de geocercas:', error);
                return Observable.throw(error);
            });
    }
}

export class UpdateGeofenceCuadrillasRequest {
    idGeofence: number;
    priorityGeofence: number;
    geofenceName: string;
    idUserApp: number[];
}

export class DetailGeofencesRequest {
    geofences: number[];
}
export class DetailGeofencesResponse {
    ids: number[];
    numberOfTickets: number;
    numberOfUsers: number;
    users: userData[];
    show?: boolean;
}

export class userData {
    extra: string;
    isUser: number;
    userName: string;
}

@Injectable()
export class TicketsGeofence {
  idGeofence: number;
  geofenceName: string;
  contrato: string;
  status: string;
  usuario: any;
  tipo: string;
  sucursal: string;
}

export class GeofenceView {
    idGeofence: number;
    name: string;
    state: string;
    city: string;
    status: boolean;
    pointViews: Array<Points>;
    // ticketTypeView: TipoTicket = new TipoTicket();
    ticketCategoryView: Array<GeofenceCategory>;
    groupId: number;
    // orderTicketsGeofenceView: Array<OrderTicketsGeofence>;
    orderRules: Array<OrderTicketsGeofence>;
    createdDate: number;
    idTicketType: number;
    //nuevos
    idSubCategoryList: number [] = [];
    idTicketCategory: number;
    polygon: string;
    filterRules: FiltroRecuperadores = new FiltroRecuperadores();
    geofenceType: number;
    visitasCant: Array <any> = [];
    idPriority: number;
}
export class GeoMultiView {
    idGeofences: Array <number> = [];
    orderRules: Array<OrderTicketsGeofence>;
    filterRules: FiltroRecuperadores = new FiltroRecuperadores();
    geofenceType?: number | null;
    idGroups?: number[]
}

export class FiltroRecuperadores {
    nivel_socioeconomico:  Array<any> = [];
    tipo_cliente:  Array<any> = [];
    plazo_forzoso: number = 0;
    antiguedad:  Antiguedad = new Antiguedad();
    tipo_contrato: number = 0;
    modalidad: number = 0;
    tipo_servicio:  Array<number> = [];
    visitas: Array<number> = [];
    orderAscDescVisits: number = 1;
    fecha_creacion: Antiguedad = new Antiguedad();
    dias_inhabilitados: number = 0;

}
export class Antiguedad {
    desde: number = 0;
    hasta: number = 0;
}

export class Geocerca {
    idGeofence: number;
    name: string;
    state: string;
    city: string;
    status: boolean;
    pointViews: Array<Points>;
    ticketTypeView: GeofenceType = new GeofenceType();
    ticketCategoryView: Array<GeofenceCategory>;
    groupId: number;
    // orderTicketsGeofenceView: Array<OrderTicketsGeofence>;
    orderRules: Array<OrderTicketsGeofence>;
    createdDate: number;
    //nuevos
    idSubCategoryList: number [] = [];
    idTicketCategory: number;
    polygon: string;
    geofenceType: number;
}

export class GeofencePageCompositiveView {
    private idGeofence: number;
    private name: string;
    private groupId: number;
    private nameGroup: string;
    private idTicketCategoy: number;
    private ticketCategory: string;
    private idTypeTicket: number;
    private typeTicket: string;
}
export class GeofencesDashboard {
    idGeofence: number;
    geofenceName: string;
    idTypeTicket: number;
    typeTicket: string;
    countTicket: number;
    ticketData: GeofenceTicketData[];
}

export interface GeofenceTicketData {
    id_ticket: number;
    summary: string;
    latitud: number;
    longitud: number;
}

export class GeocercaAdd {
    city: string;
    createdDate: number;
    idGeofence: number;
    name: string;
    pointViews: Array<Points>;
    polygon: string;
    state: string;
    status: boolean = true;
    groupId: number;
    ticketCategoryView: Array<GeofenceCategory>; //ahora idSubCategoryList
    ticketTypeView: GeofenceType = new GeofenceType(); //ahora idTicketCategory
    // orderTicketsGeofenceView: Array<OrderTicketsGeofence> = [];
    orderRules: Array<OrderTicketsGeofence> = [];
    idSubCategoryList: number [] = [];
    idTicketCategory: number;
}

@Injectable()
export class Points {
    latitude: number;
    longitude: number;
}

export class GeofenceCategory {
    idTicketCategory: number;
    categoryName: string;
}

export class GeofenceType {
    idTicketType: number;
    typeTicket: string;
}

export class UserGeofenceView {
    idGeofence: number;
    idUser: number;
    idUserGeofence: number;
    priorityGeofence: number;
}
export class OrderTicketsGeofence {
    columnName: string;
    orderType: string;
    order: number;
}
